import { Moon, Sun } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export const Footer = () => {
    const { t, lang, setLang, theme, toggleTheme } = useSite();
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="bg-chitta-deep text-white">
            <div className="mx-auto max-w-[1440px] px-5 py-16 sm:px-8 lg:px-12 lg:py-20">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <img src="/assets/chitta-logo-white.png" alt="Chitta Group" className="h-9 w-auto" width="1687" height="480" loading="lazy" />
                        <p className="mt-6 max-w-[36ch] text-sm leading-relaxed text-white/60" data-testid="footer-address">
                            {t.footer.address}
                        </p>
                    </div>
                    <nav aria-label={t.footer.navLabel} className="lg:col-span-4">
                        <p className="font-display text-xs font-medium uppercase tracking-[0.24em] text-chitta-sky">{t.footer.navLabel}</p>
                        <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-1">
                            {t.nav.map((n) => (
                                <li key={n.id}>
                                    <button
                                        type="button"
                                        data-testid={`footer-nav-${n.id}`}
                                        onClick={() => document.getElementById(n.id)?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" })}
                                        className="min-h-[44px] font-display text-sm lowercase tracking-[0.06em] text-white/70 transition-colors duration-200 hover:text-chitta-sky"
                                    >
                                        {n.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                    <div className="flex flex-col gap-5 lg:col-span-3">
                        <div
                            className="flex items-center gap-1 font-display text-xs font-semibold tracking-[0.14em]"
                            role="group"
                            aria-label={t.a11y.switchLanguage}
                            data-testid="footer-language-switcher"
                        >
                            {["en", "vi"].map((l, i) => (
                                <span key={l} className="flex items-center gap-1">
                                    {i > 0 && <span aria-hidden="true" className="text-white/30">/</span>}
                                    <button
                                        type="button"
                                        data-testid={`footer-lang-${l}`}
                                        onClick={() => setLang(l)}
                                        aria-pressed={lang === l}
                                        className={`min-h-[44px] px-2 uppercase transition-colors duration-200 ${
                                            lang === l ? "text-chitta-sky" : "text-white/60 hover:text-white"
                                        }`}
                                    >
                                        {l}
                                    </button>
                                </span>
                            ))}
                        </div>
                        <button
                            type="button"
                            onClick={toggleTheme}
                            aria-label={t.a11y.toggleTheme}
                            data-testid="footer-theme-toggle"
                            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-200 hover:border-chitta-sky hover:text-chitta-sky"
                        >
                            {theme === "dark" ? <Sun size={17} strokeWidth={1.8} /> : <Moon size={17} strokeWidth={1.8} />}
                        </button>
                    </div>
                </div>
                <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
                    <p className="text-xs tracking-wide text-white/50" data-testid="footer-copyright">
                        © {year} Chitta Group. {t.footer.rights}
                    </p>
                </div>
            </div>
        </footer>
    );
};
